import React from 'react';

import { Markdown, PageHeader } from '~/components';
import { Inner } from '~/styles';

import markdown from './Documents/SweepProgramDepositPlacementCustodialAgreements.md';

export const PageSweepProgramDepositPlacementCustodialAgreements: React.FC = () => {
  return (
    <>
      <PageHeader text="Column Sweep Program Deposit Placement and Custodial Agreements" />
      <Inner pt={0}>
        <Markdown markdown={markdown} />
      </Inner>
    </>
  );
};
